// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import moment from 'moment/moment'
import { Tooltip } from 'ui_kit_qmd'
import { useNavigate } from 'react-router-dom'
import upIcon from '../../../../images/common/ChevronUp.png'
import { PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH } from '../../../../utils/constants'
import { parseUserDateTime } from '../../../../utils/common'

export const IntakeFormsCard = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  name,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  completeDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitType,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  id,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sessionId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isQuestionnaire,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  chartsId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  userTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientChartsSearchRow,
}) => {
  const formattedCompleteDate = parseUserDateTime(completeDate, userTimeZone, false)
  const navigate = useNavigate()

  const onClickChevronBtn = () => {
    const query = isQuestionnaire ? `id=${chartsId}&sessionId=${sessionId}` : `id=${chartsId}&intakeFormId=${id}`
    void navigate(`${PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH}/?${query}`, {
      state: { patientChartsSearchRow },
    })
  }

  return (
    <section className='intake-section'>
      <div className='intake-section--title'>
        <Tooltip content={name} targetId={`${id}-name`}>
          <div className='intake-section--name intake-section-tooltip-text' id={`${id}-name`}>
            {name}
          </div>
        </Tooltip>
        <button type='submit' className='intake-section--chevron-icon-container' onClick={onClickChevronBtn}>
          <img className='intake-section--chevron-icon' src={upIcon} alt='chevron' />
        </button>
      </div>
      <Tooltip content={formattedCompleteDate} targetId={`${id}-complete`}>
        <div className='intake-section--complete intake-section-tooltip-text' id={`${id}-complete`}>
          Completed on: {formattedCompleteDate}
        </div>
      </Tooltip>
      <Tooltip content={visitType} targetId={`${id}-visit-type`}>
        <div className='intake-section--visit-type intake-section-tooltip-text' id={`${id}-visit-type`}>
          Visit type: {visitType}
        </div>
      </Tooltip>
    </section>
  )
}
